import React from 'react';

import Layout from 'client/app/apps/disco-prototype/UploadDataPage/Layout';
import Page from 'client/app/apps/disco-prototype/UploadDataPage/Page';

export default () => (
  <Layout>
    <Page />
  </Layout>
);
